import { useTheme } from "app/shared";

import styles from "./CommissionTiers.module.scss";

const ACCENT = "#4BC0C0";

const CommissionTiers = () => {
  const { theme } = useTheme();

  return (
    <div
      className={`${styles.container} ${
        theme === "dark" ? styles.darkTheme : ""
      }`}
    >
      <h3 className={styles.title}>Your Referral Commission</h3>

      <div
        className={`${styles.tier} ${styles.activeTier}`}
        style={{ borderColor: ACCENT, backgroundColor: `${ACCENT}20` }}
      >
        <div className={styles.tierHeader}>
          <span
            className={styles.tierName}
            style={{ color: ACCENT, fontSize: 26 }}
          >
            up to 1%<sup>*</sup>
          </span>
        </div>
        <div className={styles.tierDescription}>
          of every purchase made through your referral link
        </div>
      </div>

      <ul style={{ margin: "16px 0 0", paddingLeft: 18, lineHeight: 1.6 }}>
        <li>Calculated automatically and embedded in the smart contract.</li>
        <li>
          Paid to you automatically after every transaction — no claim needed.
        </li>
      </ul>

      <p style={{ marginTop: 12, fontSize: 12, opacity: 0.7 }}>
        * The commission rate may change.
      </p>
    </div>
  );
};

export default CommissionTiers;
